module.exports = __webpack_public_path__ + "img/logs.5d19cf64.svg";